
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiInProgress2 as ObiInProgress2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-in-progress-2.js';
 
 
 

 
 export const ObiInProgress2 = createComponent({
   react: React,
   tagName: 'obi-in-progress-2',
   elementClass: ObiInProgress2Element,
   events: {
     
   }
  });
 
 